/**
 * 判断文案是否触发了省略号显示
 * 此方法必须配合 text-ellipsis-1 使用
 */
export default function isTextEllipsis(element) {
  const elementWidth = element.getBoundingClientRect().width; // 获取元素的可见宽度

  // 必须设置为不换行，才能判断文案宽度是否超出容器宽度
  element.style['white-space'] = 'nowrap'

  const range = document.createRange();
  const textNode = element.firstChild; // 获取元素的文本节点

  // 如果元素没有文本，直接返回 false
  if (!textNode) return false;

  range.setStart(textNode, 0); // 设置 Range 的开始位置
  range.setEnd(textNode, textNode.length); // 设置 Range 的结束位置

  const rangeWidth = range.getBoundingClientRect().width; // 获取文本的实际宽度
  
  element.style['white-space'] = 'normal'

  // 如果文本的宽度大于元素的可见宽度，说明溢出了
  return rangeWidth > elementWidth;
}
